import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

export default function PhoneField(props) {
  const onChange = (phone) => {
    props.onChange(`+${phone}`);
  };

  const checkValidityonBlur = (e) => {
    if (props.value?.length >= 12) {
      props.onChange(props.value);
    }
  };

  const onPasteValue = (e) => {
    let paste = (e.clipboardData || window.clipboardData).getData("text");
    if (paste) {
      // cleanup number
      paste = paste.replace(/[^\d+]/g, "");

      if (paste.startsWith("+")) {
        props.onChange(paste);
        e.preventDefault();
      } else if (paste.length > 10) {
        props.onChange(`+1${paste.slice(-10)}`);
        e.preventDefault();
      } else {
        // do nothing
      }
    }
  };

  return (
    <PhoneInput
      country={"us"}
      value={props.value}
      onChange={(phone) => onChange(phone)}
      onBlur={checkValidityonBlur}
      inputClass="phone"
      containerClass="phone"
      containerStyle={props.style || {}}
      specialLabel={props.name}
      countryCodeEditable={false}
      disabled={props.disabled}
      inputProps={{ onPaste: (e) => onPasteValue(e) }}
    />
  );
}
